module.exports = __webpack_public_path__ + "static/img/bg1.5b8b53a.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/connect/bg1.png
// module id = ULkb
// module chunks = 7